import { useViewerEntity } from '@rahtab/auth/lib/token-based-auth';
import LandingScreen from '@rahtab/system/lib/screens/LandingScreen';
import { Button, Picker, getSpacing } from '@rahtab/ui';
import { StackScreenProps } from '@react-navigation/stack';
import React, { FC, useState } from 'react';
import { StyleSheet } from 'react-native';
import type { RootStackType } from '../Router';

const backgroundImage = require('assets/images/landing.png');

type LandingScreenProps = StackScreenProps<RootStackType, 'Landing'>;

const Landing: FC<LandingScreenProps> = () => {
  const { viewerEntityList, selectViewerEntity } = useViewerEntity();
  const [selectedEntity, setSelectedEntity] = useState<string>(viewerEntityList[0]?.typeCode.toString());
  return (
    <LandingScreen title="لطفا نقش کسب‌وکار خود را انتخاب نمایید." backgroundImage={backgroundImage}>
      {viewerEntityList.map((item) => (
        <Picker.Item
          key={item.typeCode}
          label={`${item.label} | ${item.name}`}
          value={item.typeCode.toString()}
          _selectedValue={selectedEntity}
          _onPress={({ value }) => setSelectedEntity(value)}
        />
      ))}
      <Button
        style={{ marginTop: getSpacing() }}
        text="تایید"
        color="secondary"
        onPress={() => selectViewerEntity(parseInt(selectedEntity, 10))}
      />
    </LandingScreen>
  );
};

export default Landing;

const styles = StyleSheet.create({
  notRegisteredView: {
    marginTop: getSpacing(),
    flexDirection: 'row',
    justifyContent: 'center',
  },
});
